/* Yuvakart — header account icon: person + lightning bolt.

   Traced from the supplied 68x90 reference:
     person stroke  #84766C, ~5px on that canvas
     bolt fill      #F1A63B
     the head is an OPEN arc, not a closed circle
     the person's stroke is interrupted where the bolt crosses,
     which is what gives the layered look
   The interruption uses a mask rather than chopped paths, so the
   gap stays correct at any rendered size. */
(function(){

  var BOLT = 'M45 21 L28.5 43 H37 L33 59 L49.5 36 H41 Z';
  var n = 0;

  function svg(id){
    return '' +
    '<svg viewBox="2 14 60 60" width="22" height="22" fill="none" aria-hidden="true">' +
      '<defs><mask id="' + id + '" maskUnits="userSpaceOnUse" x="2" y="14" width="60" height="60">' +
        '<rect x="2" y="14" width="60" height="60" fill="#fff"/>' +
        '<path d="' + BOLT + '" fill="#000" stroke="#000" stroke-width="6" stroke-linejoin="round"/>' +
      '</mask></defs>' +
      '<g mask="url(#' + id + ')" stroke="#84766C" stroke-width="5" stroke-linecap="round" fill="none">' +
        '<circle cx="29" cy="31" r="6.6"/>' +
        '<path d="M16.5 61 A14.5 14.5 0 0 1 45.5 61"/>' +
      '</g>' +
      '<path d="' + BOLT + '" fill="#F1A63B"/>' +
    '</svg>';
  }

  function swap(){
    var boxes = document.querySelectorAll('.yk-actions, .header__icons, .header-actions');
    for (var b = 0; b < boxes.length; b++){
      var links = boxes[b].querySelectorAll('a');
      for (var i = 0; i < links.length; i++){
        var href = links[i].getAttribute('href') || '';
        if (href.indexOf('account') === -1) continue;
        if (links[i].getAttribute('data-ykacc')) continue;
        var old = links[i].querySelector('svg');
        if (!old) continue;
        var holder = document.createElement('div');
        holder.innerHTML = svg('ykaccmask' + (++n));
        var fresh = holder.firstChild;
        if (!fresh) continue;
        old.parentNode.replaceChild(fresh, old);
        links[i].setAttribute('data-ykacc', '1');
      }
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', swap);
  } else { swap(); }

  setTimeout(swap, 300);
  setTimeout(swap, 900);
  setTimeout(swap, 1800);
  window.addEventListener('load', swap);

  try {
    new MutationObserver(function(){ swap(); })
      .observe(document.body, { childList:true, subtree:true });
  } catch(e){}
})();